import styled from 'styled-components'
import { cores } from '../../styles'

export const Corretor = styled.div`
  display: flex;
  align-items: center;
`

export const ImgCorretores = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  width: 150px;
  height: 150px;
  border: 1px solid ${cores.cinza};
  border-radius: 6px;
  background-size: cover;

  img {
    height: 148px;
  }
`

export const Dados = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 10px;
  color: ${cores.azul};

  p {
    font-size: 14px;
  }

  a {
    font-size: 12px;
    text-decoration: underline;
    color: ${cores.laranja};
    cursor: pointer;
  }

  span {
    padding-top: 20px;
    display: none;

    &.is-visible {
      display: block;
    }
  }
`
